import { ConversationFiltersV3 } from "./conversation-filters";
import { SystemView } from "./system-view";

export function scrubFilterFieldsThatArentStoredInTheDatabase(
  filters: ConversationFiltersV3,
  viewName?: string,
): ConversationFiltersV3 {
  const filtersCopy = { ...filters };
  delete filtersCopy.search;
  delete filtersCopy.customerEmail;

  /** If it's a system default view, we don't store the sort direction in the database */
  if (viewName && (Object.values(SystemView) as string[]).includes(viewName)) {
    delete filtersCopy.sort;
  }
  return filtersCopy;
}

export function formatFiltersForDatabase(
  filters: ConversationFiltersV3,
): ConversationFiltersV3 {
  return scrubFilterFieldsThatArentStoredInTheDatabase(filters);
}
